import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NiceSelectModule } from "ng-nice-select";

import { CoreModule } from '@teem/core/core.module';
import { SharedModule } from '@teem/shared/shared.module';

import { ProposalsRoutingModule } from '@teem/proposals-module/proposals-routing.module';
import { ProposalsComponent } from '@teem/proposals-module/proposals.component';

import { CreateProposalComponent } from '@teem/proposals-module/create-proposal/create-proposal.component';
import { ProjectDetailComponent } from '@teem/proposals-module/create-proposal/project-detail/project-detail.component';
import { ClientDetailComponent } from '@teem/proposals-module/create-proposal/client-detail/client-detail.component';
import { QuotesComponent } from '@teem/proposals-module/create-proposal/quotes/quotes.component';
import { TermsComponent } from '@teem/proposals-module/create-proposal/terms/terms.component';
import { OverviewComponent } from '@teem/proposals-module/create-proposal/overview/overview.component';
import { PaymentInfoModalComponent } from '@teem/proposals-module/modals/payment-info-modal/payment-info-modal.component';

import { ViewProposalComponent } from '@teem/proposals-module/view-proposal/view-proposal.component';

import { EditProposalComponent } from '@teem/proposals-module/edit-proposal/edit-proposal.component';
import { ProjectDetailComponent as EditProjectDetailComponent } from '@teem/proposals-module/edit-proposal/project-detail/project-detail.component';
import { ClientDetailComponent as EditClientDetailComponent } from '@teem/proposals-module/edit-proposal/client-detail/client-detail.component';
import { QuotesComponent as EditQuotesComponent } from '@teem/proposals-module/edit-proposal/quotes/quotes.component';
import { TermsComponent as EditTermsComponent } from '@teem/proposals-module/edit-proposal/terms/terms.component';
import { OverviewComponent as EditOverviewComponent } from '@teem/proposals-module/edit-proposal/overview/overview.component';
import { EditTermModalComponent } from '@teem/proposals-module/modals/edit-term-modal/edit-term-modal.component';

@NgModule({
  declarations: [
    ProposalsComponent,
    CreateProposalComponent,
    ProjectDetailComponent,
    ClientDetailComponent,
    QuotesComponent,
    TermsComponent,
    OverviewComponent,
    PaymentInfoModalComponent,
    ViewProposalComponent,
    EditProposalComponent,
    EditProjectDetailComponent,
    EditClientDetailComponent,
    EditQuotesComponent,
    EditTermsComponent,
    EditOverviewComponent,
    EditTermModalComponent
  ],
  entryComponents: [
    PaymentInfoModalComponent,
    EditTermModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
    ProposalsRoutingModule
  ]
})
export class ProposalsModule { }
